export const INVALID_PWD = 101
export const NEW_PWD_SAME_AS_OLD = 102
